import { HttpService, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { MS_PER_MINUTE, extractFilenameFromHeaders } from '@skylab-shared/utils';
import { AxiosResponse } from 'axios';
import { ExportQueryParameters } from '../../common/export/export-query.parameters';
import { ExportResult } from '../../common/export/export-query.result';
import { ExportQuery } from '../../common/export/export.query-base';


export interface ReportInventoryStocktakingExportParameters extends ExportQueryParameters { }

export class ReportInventoryStocktakingExportQuery extends ExportQuery<ExportResult> {
    public constructor(parameters: ReportInventoryStocktakingExportParameters) {
        super(parameters);
    }
}

export class ReportInventoryStocktakingExportQueryHandlerBase implements QueryHandler<ReportInventoryStocktakingExportQuery, ExportResult> {
    private static Url = TaggedUrl.join('inventoryStocktaking/export', [Tags.Api]);

    public constructor(private readonly http: HttpService) {  }

    public async handleAsync({ parameters }: ReportInventoryStocktakingExportQuery): Promise<ExportResult> {
        const requestData = {
            compress: parameters.compress,
            password: parameters.password,
            config: {
                parameters: JSON.stringify(parameters.parameters),
                columns: parameters.columns,
            }
        };

        const response = await this.http.post<Blob>(ReportInventoryStocktakingExportQueryHandlerBase.Url, requestData, { responseType: 'blob', timeout: 3 * MS_PER_MINUTE });

        return {
            file: response.data,
            filename: extractFilenameFromHeaders(<AxiosResponse<Blob>>response) ?? ''
        };
    }
}
